<template>
	<section class="cta-area-v2 main-bg pt-90 pb-100">
		<div
			class="cta-bg bg_cover"
			:style="{ 'background-image': `url(${section.image})` }"
		></div>
		<div class="container">
			<div class="row">
				<div class="col-lg-6">
					<Markdown :text="section.content" />
				</div>
			</div>
		</div>
	</section>
</template>

<script lang="ts">
import { defineComponent } from 'vue';
import Markdown from '@/plugins/markdown.vue';
import { Section } from '@/interfaces';

export default defineComponent({
	components: {
		Markdown,
	},
	props: {
		section: {
			type: Object as () => Section,
			required: true,
		},
	},
});
</script>

<style lang="scss" src="./VCta.scss"></style>
